<span class="ets-tab" [ngClass]="{'active': tab?.isActive}">
   
   <i class="fas fa-link" 
      *ngIf="this.tab.isSymbolLinkCompatible"
      [ngClass]="{'linked': this.tab.isLinkedToSymbol}"
      (click)="this.onSymbolLinkedClicked()" ></i>
   
   <span class="ets-tab-text" *ngIf="!isEditing" (dblclick)="onDoubleClick($event)" [title]="tab?.header">{{displayName}}</span>
   <span class="ets-tab-editor" *ngIf="isEditing">
      <dx-text-box [value]="tab?.customHeader || ''"
                   [placeholder]="placeholder"
                   (onValueChanged)="onTextChanged($event)"
                   (onEnterKey)="onEnterKey($event)"
                   (onKeyUp)="onKeyUp($event)"></dx-text-box>
   </span>
   <span class="ets-tab-close-button" (click)="this.onCloseClick($event)" *ngIf="canClose"></span>
</span>
